import {
  ComboBox,
  InputMaskField,
  LoadingBarIndicator,
  TextInput,
  Button,
} from '@components';
import { marital, states } from '@utils';
import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import api from '../../../../common/services/api';

export const DadosResidenciaisForm = ({ isEdit, setIsEdit, isActive }) => {
  const user = useSelector((state) => state.user);
  const [errorCep, setCepError] = useState(null);
  const [loadingCEP, setLoadingCEP] = useState(false);

  const { resetForm, setFieldValue, setTouched } = useFormikContext();

  useEffect(() => {
    if (isEdit && isActive) {
      setTouched(
        {
          cep: true,
          estado: true,
          cidade: true,
          bairro: true,
          complmento: true,
          numero: true,
          endereco: true,
        },
        true
      );
    }
  }, [isActive, isEdit, setTouched]);

  async function fetchAddressByPostalCode(postalCode) {
    const sanitizedPostalCode = postalCode.replace(/\D/g, '');

    try {
      const response = await api.get('ObterDadosEnderecoCEP', {
        params: {
          cep: sanitizedPostalCode,
        },
      });

      if (response.data.erro) {
        throw new Error('CEP não encontrado');
      }
      return response.data;
    } catch (error) {
      setCepError('CEP inválido. Verifique e tente novamente.');
      return null;
    }
  }

  return (
    <>
      <div className="col-md-12">
        {isEdit && (
          <div className="d-flex justify-content-between mt-4 mb-4">
            <h3 className="mb-32 ts-16 fw-bold">
              Editando: Dados Residenciais
              <div className="row">
                <p className="text-orange ts-16 mt-2">
                  Atenção: para salvar suas alterações, você precisa avançar até
                  a última etapa do formulário.
                </p>
              </div>
            </h3>
            <div className="col-md-2 d-flex justify-content-end">
              <Button
                type="button"
                color="orange"
                transparent
                onClick={() => {
                  setIsEdit(false);
                  resetForm();
                }}
                className="d-flex justify-content-center"
              >
                Cancelar edição
              </Button>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-md-12 col-lg-6">
          <Field
            name="cep"
            disabled={!isEdit}
            className="mb-3"
            mask="11.111-111"
            inputMode="numeric"
            component={InputMaskField}
            label="CEP"
            onBlur={(e) => {
              setCepError(null);
              setLoadingCEP(true);

              const postalCode = e.target.value.replace(/\D/g, '');

              if (postalCode.length === 8) {
                fetchAddressByPostalCode(postalCode).then((addressData) => {
                  if (addressData) {
                    setFieldValue('cep', postalCode);
                    setFieldValue('endereco', addressData.logradouro);
                    setFieldValue('bairro', addressData.bairro);
                    setFieldValue('cidade', addressData.localidade);
                    setFieldValue('estado', addressData.uf);
                    setFieldValue('numero', '');
                    setFieldValue('complemento', '');
                    setLoadingCEP(false);
                  }
                });
              }
            }}
          />
          {errorCep && (
            <div className="validation-error mb-2" style={{ marginTop: -20 }}>
              {' '}
              {errorCep}
            </div>
          )}

          {loadingCEP ? (
            <LoadingBarIndicator />
          ) : (
            <>
              <Field
                name="endereco"
                disabled={!isEdit}
                className="mb-3"
                component={TextInput}
                label="Logradouro"
              />
              <Field
                name="numero"
                disabled={!isEdit}
                className="mb-3"
                type="number"
                component={TextInput}
                label="Número"
              />
              <Field
                name="complemento"
                disabled={!isEdit}
                className="mb-3"
                component={TextInput}
                label="Complemento"
              />
            </>
          )}
        </div>
        <div className="col-md-12 col-lg-6">
          {loadingCEP ? (
            <LoadingBarIndicator />
          ) : (
            <>
              <Field
                name="bairro"
                disabled={!isEdit}
                className="mb-3"
                component={TextInput}
                label="Bairro"
              />
              <Field
                name="cidade"
                disabled={!isEdit}
                className="mb-3"
                component={TextInput}
                label="Cidade"
              />
              <Field
                name="estado"
                disabled={!isEdit}
                className="mb-3"
                component={ComboBox}
                label="Estado"
                options={states.map((s) => {
                  return { value: s.sigla, label: s.estado };
                })}
              />
            </>
          )}
        </div>
      </div>
      {(user.dadosPessoais.estadoCivil === '' ||
        user.dadosPessoais.estadoCivil === 'Outros') && (
        <>
          <hr />
          <div className="row mt-32 mb-32">
            <p className="ts-16">
              Verificamos que você não possui estado civil informado. Pedimos
              que preencha também o campo abaixo, por favor:
            </p>
            <Field
              name="estadoCivil"
              className="mb-3 mt-3 col-12 col-md-4"
              disabled={!isEdit}
              component={ComboBox}
              label="Estado Civil"
              options={marital.map((s) => {
                return { value: s, label: s };
              })}
            />
          </div>
        </>
      )}
    </>
  );
};
